import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteStockreportsFromAPI, fetchStockreportsFromAPI, downloadStockFileFromAPI, downloadStockSummaryPDFFromAPI, downloadStockSummaryExcelFromAPI } from "../../../services/StockreportService";


export const fetchStockreports = createAsyncThunk(
  "stockreports/fetchStockreports",
  async ({ page, perPage, search, columnFilters }, { rejectWithValue, signal }) => {
    try {
      const response = await fetchStockreportsFromAPI(page, perPage, search, columnFilters, signal);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteStockreport = createAsyncThunk(
  "stockreports/deleteStockreport",
  async (stockreportId, { rejectWithValue }) => {
    try {
      const response = await deleteStockreportsFromAPI(stockreportId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);


// Download Forecast File
export const downloadStockFile = createAsyncThunk(
  "stockreports/downloadStockFile",
  async ({ fileType, search }, { rejectWithValue }) => {
    try {
      const response = await downloadStockFileFromAPI(fileType, search);
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Failed to download forecast file.");
    }
  }
);

// Download Stock Summary PDF
export const downloadStockSummaryPDF = createAsyncThunk(
  "stockreports/downloadStockSummaryPDF",
  async ({ search }, { rejectWithValue }) => {
    try {
      const response = await downloadStockSummaryPDFFromAPI(search);
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Failed to download stock summary PDF.");
    }
  }
);

// Download Stock Summary Excel
export const downloadStockSummaryExcel = createAsyncThunk(
  "stockreports/downloadStockSummaryExcel",
  async ({ search }, { rejectWithValue }) => {
    try {
      const response = await downloadStockSummaryExcelFromAPI(search);
      return response;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error.response?.data || "Failed to download stock summary Excel.");
    }
  }
);


const stockreportSlice = createSlice({
  name: "stockreports",
  initialState: {
    stockreports: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    stockreportSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    keywordSearch:"",
    columnFilters: {} // New state for column-specific filters
  },
  reducers: {
    setSearchStockreport: (state, action) => {
      state.stockreportSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockreports.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchStockreports.fulfilled, (state, action) => {
        const stockreports = action.payload.reports;
        state.loading = false;
        state.stockreports = stockreports.data;
        state.currentPage = stockreports.current_page;
        state.lastPage = stockreports.last_page;
        state.perPage = stockreports.per_page;
        state.firstItem = stockreports.from; // ✅ Ambil `from` dari API
        state.totalCount = stockreports.total;
      })
      .addCase(fetchStockreports.rejected, (state, action) => {
        if (action.meta?.aborted) return;
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteStockreport.fulfilled, (state, action) => {
        state.stockreports = state.stockreports.filter(stockreport => stockreport.id !== action.payload);
      })
      .addCase(deleteStockreport.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setSearchStockreport, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters } = stockreportSlice.actions;
export default stockreportSlice.reducer;



